import React from "react";
import styles from "./AboutSec.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const AboutSec = ({
  subHeading,
  heading,
  headingSpan=false,
  text,
  buttonText,
  buttonLink,
  reverse,
  backgroundImage,
  backgroundGradient,
  img=false,
  imgLink,
  cta,
  ctaSteve=false,
  cta6525=false,
  padding,
  imgBorderRad=false
}) => {
  return (
    <div
      style={{
        backgroundImage: backgroundImage
          ? `url("/images/video_background.jpg")`
          : backgroundGradient && backgroundGradient,
        padding: padding && padding,
      }}
      className={styles.main}
    >
      <Container>
        <Row
          style={{ flexDirection: reverse && "row-reverse" }}
          className="gy-4 gx-lg-5"
        >
          {img &&
          <Col lg={6}>
            <div className={styles.imgCol}>
              {!imgLink && <img style={{maxHeight:"560px",borderRadius:`${imgBorderRad?"20px":"0px"}`,height:`${imgBorderRad?"auto":""}`}} alt="side-img" src={img} />}
              {imgLink && (
                <a href={imgLink} target="no_blank">
                  <img alt="side-img" src={img}  />
                </a>
              )}
            </div>
          </Col>
          }
          <Col lg={img?6:12}>
            <div className={`${styles.contentCol} ${!img ? styles.noImageContentSection : ''}`}>
              {subHeading && <h3 className="h2_main">{subHeading}</h3>}
              <h2 className="h1_main">{heading} {headingSpan && <span>{headingSpan}</span>}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="para_main pt-2 pb-4"
              />
              {buttonText && (
                <Link to={buttonLink}>
                  <button className="button_main">{buttonText}</button>
                </Link>
              )}
              {ctaSteve ? (
  <a href="tel:289-981-7825" className="button_main">
    <img alt="icon" src="/images/icons/phone.svg" />
    289-981-7825
  </a>
) : cta6525 ?
  (<a href="tel:905-462-6525" className="button_main">
    <img alt="icon" src="/images/icons/phone.svg" />
    905-462-6525
  </a>)
  :
cta ? (
  <a href="tel:905-299-7841" className="button_main">
    <img alt="icon" src="/images/icons/phone.svg" />
    905-299-7841
  </a>
) : null}

              {/* {cta && (
                <a href="tel: 905-299-7841">
                  <button className="button_main">
                    <img alt="icon" src="/images/icons/phone.svg" />
                    905-299-7841
                  </button>
                </a>
              )} */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutSec;
